import {AttributeType} from '../types';
import {TYPE_LABELS} from '../locales';

/**
 * Get attribute template type label from type
 * @param type Attribute template type
 * @return Attribute template type label
 */
export const getTypeLabel = (type: AttributeType) =>
	TYPE_LABELS[type] || 'unknown';

export default getTypeLabel;
